import { LeafletPixiContext, PixiState, UseStateType } from "./useLeafletPixi";
import { useEffect } from "react";
import { FigureEnum } from "../../../../components/modules/map/drawer/Drawer";
import FieldService from "../../../../context/map/fields/fieldsStore";
import { ModeEnum } from "../../../../components/modules/map/MapContainer";
import logger from "../../../../utils/logger";
import { useTypedSelector } from "@hooks/useTypedSelector";

const log = logger.getLogger("pixi.useMapMode")
export default function (pixiContext: LeafletPixiContext | undefined, [state, setPixiState]: UseStateType<PixiState>) {
    const { entities: GeoZoneData, ids: geoZoneIds } = useTypedSelector(data => data.geoZones)
    useEffect(() => {
        if (pixiContext) {
            let glidFigure = state.selectedGeoZones[0]

            log.debug("Map mode changed", state.mapMode, glidFigure)
            switch (state.mapMode) {
                case ModeEnum.MISSION_EDITOR: {
                    pixiContext.drawer.createEditor({
                        type: FigureEnum.MARKER,
                        data: glidFigure
                    })
                    break;
                }
                case ModeEnum.POLYGON_EDITOR: {
                    let figurePolygon = GeoZoneData[glidFigure]
                    if (figurePolygon) {
                        FieldService.setFilters({ value: figurePolygon.glid, action: "ADD" })
                    }
                    pixiContext.drawer.createEditor({
                        type: FigureEnum.POLYGON,
                        data: figurePolygon,
                    })
                    break;
                }
                case ModeEnum.BASE: {
                    if (glidFigure) {
                        FieldService.setFilters({ value: glidFigure, action: "REMOVE" })
                    }
                    pixiContext.drawer.disableDraw();
                    break;
                }
            }
        }
    }, [pixiContext, state.mapMode, state.selectedGeoZones, geoZoneIds])
}